import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  getMarketingConsent,
  isMarketingPath,
  onConsentBannerOpen,
  setMarketingConsent,
  type MarketingConsent,
} from '../../lib/consent';
import './CookieConsentBanner.css';

/**
 * Banner de consentimiento de cookies de marketing (Meta Pixel).
 * No bloquea la página. Aceptar y Rechazar tienen el mismo peso visual:
 * rechazar tiene que ser tan fácil como aceptar.
 */
export default function CookieConsentBanner() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(() => getMarketingConsent() === null);

  useEffect(() => onConsentBannerOpen(() => setOpen(true)), []);

  if (!open || !isMarketingPath(pathname)) return null;

  const decide = (value: MarketingConsent) => {
    setMarketingConsent(value);
    setOpen(false);
  };

  return (
    <section className="cc-consent" role="region" aria-label="Preferencias de cookies">
      <p className="cc-consent__text">
        Usamos cookies de Google Analytics para medir las visitas al sitio y de Meta para medir nuestras campañas
        en Facebook e Instagram. Solo se activan si las aceptas y nunca reciben lo que escribes en formularios ni
        datos de tu atención.{' '}
        <Link to="/privacidad#cookies" className="cc-consent__link">
          Más información
        </Link>
      </p>
      <div className="cc-consent__actions">
        <button type="button" className="cc-consent__btn" onClick={() => decide('denied')}>
          Rechazar
        </button>
        <button type="button" className="cc-consent__btn" onClick={() => decide('granted')}>
          Aceptar
        </button>
      </div>
    </section>
  );
}
